import React from "react"

import {
  ClerkLoaded,
  SignedIn as ClerkSignedIn,
  SignedOut as ClerkSignedOut,
  useAuth as clerkUseAuth,
} from "@clerk/clerk-react"

export const AuthLoaded: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (import.meta.env.REACT_APP_OFFLINE) {
    return children
  }
  return <ClerkLoaded>{children}</ClerkLoaded>
}

export const SignedIn: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (
    import.meta.env.REACT_APP_OFFLINE &&
    import.meta.env.REACT_APP_OFFLINE_JWT
  ) {
    return children
  }

  return <ClerkSignedIn>{children}</ClerkSignedIn>
}

export const SignedOut: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (import.meta.env.REACT_APP_OFFLINE) {
    if (!import.meta.env.REACT_APP_OFFLINE_JWT) {
      console.warn("Offline mode is enabled, but no JWT is set!")
      return children
    }
    return null
  }

  return <ClerkSignedOut>{children}</ClerkSignedOut>
}

type UseAuthReturn = {
  getToken: () => Promise<string | null>
  isSignedIn: boolean
  isLoaded: boolean
  hasOrg: boolean
}
export const useAuth = (): UseAuthReturn => {
  if (import.meta.env.REACT_APP_OFFLINE) {
    return {
      getToken: async () => import.meta.env.REACT_APP_OFFLINE_JWT,
      isSignedIn: true,
      isLoaded: true,
      hasOrg: true,
    }
  }
  const clerkUseAuthReturn = clerkUseAuth()
  return {
    getToken: clerkUseAuthReturn.getToken,
    isSignedIn: clerkUseAuthReturn.isSignedIn ?? false,
    isLoaded: clerkUseAuthReturn.isLoaded,
    hasOrg: !!clerkUseAuthReturn.orgId,
  }
}
